import { apiClient } from './config'

export const artisansService = {
  async getArtisans(params = {}) {
    const { q, city, featured, availability, page = 1, limit = 20 } = params
    const queryParams = new URLSearchParams()
    
    if (q) queryParams.append('q', q)
    if (city) queryParams.append('city', city)
    if (featured !== undefined) queryParams.append('featured', featured)
    if (availability) queryParams.append('availability', availability)
    queryParams.append('page', page)
    queryParams.append('limit', limit)
    
    return apiClient.get(`/artisans?${queryParams.toString()}`)
  },

  async getArtisanById(id) {
    return apiClient.get(`/artisans/${id}`)
  },

  async contactArtisan(id, message, phone) {
    return apiClient.post(`/artisans/${id}/contact`, { message, phone })
  },

  async recordView(id) {
    return apiClient.post(`/artisans/${id}/view`)
  },
}

export const categoriesService = {
  async getCategories() {
    return apiClient.get('/categories')
  },
}
